"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.seal");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _wedding = require("@/api/wedding");
var _ossUpload = require("@/utils/ossUpload");
var _editorForVue = require("@wangeditor/editor-for-vue");
var _member = require("@/api/member/member");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Promotions',
  components: {
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar
  },
  data: function data() {
    var _this = this;
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value > _this.ruleForm.perLimit) {
        callback(new Error('商品可购次数需要 <= 每人限购次数'));
      } else {
        callback();
      }
    };
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl);
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log('error ->', _t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      mode: 'default',
      // or 'simple'
      EditorOpen: true,
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      greadOption: [],
      realObj: {
        0: '#E6A23C',
        1: '#67C23A',
        2: '#F56C6C'
      },
      queryData: {
        activityName: '',
        status: null,
        page: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      eventsType: '',
      ruleForm: {
        id: null,
        activityName: '',
        headPic: '',
        tagPic: '',
        userType: '',
        userGrade: '',
        perLimit: '',
        goodsLimit: '',
        bgColor: '#F8F8F8',
        remark: '',
        ruleTxt: null,
        timeArray: [],
        startTime: '',
        //	活动开始时间
        endTime: '' //	活动结束时间
      },
      boole: false,
      rules: {
        bgColor: [{
          required: true,
          message: '请输入背景颜色',
          trigger: 'blur'
        }],
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        perLimit: [{
          required: true,
          message: '请输入每人限购次数',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '必须为数字值'
        }],
        goodsLimit: [{
          validator: validatePass2,
          required: true,
          trigger: 'blur'
        }, {
          type: 'number',
          message: '必须为数字值'
        }],
        userType: [{
          required: true,
          message: '请选择用户类型',
          trigger: 'change'
        }],
        ruleTxt: [{
          required: false,
          message: '请输入',
          trigger: 'change'
        }],
        timeArray: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }],
        userGrade: [{
          required: true,
          message: '请选择等级',
          trigger: 'change'
        }],
        headPic: [{
          required: true,
          message: '请上传头图',
          trigger: 'change'
        }],
        tagPic: [{
          required: false,
          message: '请上传标签图',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.activityList();
    this.getGread();
  },
  methods: {
    copy: function copy(val) {
      var _this2 = this;
      this.$copyText(val.openUrl).then(function () {
        _this2.$notify.success({
          title: '温馨提示',
          message: '拷贝成功'
        });
      }).catch(function () {
        _this2.$notify.success({
          title: '温馨提示',
          message: '拷贝失败，请手动复制'
        });
      });
    },
    look: function look() {},
    handleFileUpload1: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(_ref) {
        var file, pictureUrl, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = _ref.file;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context2.v;
              this.ruleForm.tagPic = pictureUrl;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log('error ->', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleFileUpload1(_x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload1;
    }(),
    handleFileUpload: function () {
      var _handleFileUpload2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(_ref2) {
        var file, pictureUrl, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              file = _ref2.file;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context3.v;
              this.ruleForm.headPic = pictureUrl;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.log('error ->', _t3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleFileUpload(_x4) {
        return _handleFileUpload2.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    getGread: function getGread() {
      var _this3 = this;
      (0, _member.memberQueryMemberGradeApi)({}).then(function (res) {
        console.log(res);
        _this3.greadOption = res.data;
      });
    },
    typeChange: function typeChange() {
      if (this.ruleForm.userType === 1) {
        this.ruleForm.perLimit = 1;
        this.ruleForm.goodsLimit = 1;
      }
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.$confirm("\u662F\u5426\u786E\u8BA4".concat(_this4.eventsType === 'add' ? '添加' : '编辑', "\u6B64\u6D3B\u52A8?"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            if (_this4.ruleForm.timeArray[0]) {
              _this4.ruleForm.startTime = _this4.ruleForm.timeArray[0];
              _this4.ruleForm.endTime = _this4.ruleForm.timeArray[1];
            }
            (0, _wedding.change_act)(_this4.ruleForm).then(function (res) {
              if (res.data) {
                _this4.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                _this4.handleClose();
                _this4.onInquire();
              }
            });
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.initRuleForm();
      this.$refs[formName].resetFields();
    },
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    formatDate: function formatDate(d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    // 添加
    onAdd: function onAdd() {
      this.eventsType = 'add';
      this.initRuleForm();
      var end = new Date();
      var start = new Date();
      end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
      start.setHours(0, 0, 0, 0); // 设置为00:00:00
      end.setHours(23, 59, 59, 999); // 设置为23:59:59
      this.ruleForm.timeArray = [this.formatDate(start), this.formatDate(end)];
      this.dialogVisible = true;
    },
    detail: function detail(val) {
      var _this5 = this;
      (0, _wedding.query_act)({
        id: val.id
      }).then(function (res) {
        _this5.eventsType = 'upDate';
        _this5.initRuleForm();
        res.data['timeArray'] = [res.data.startTime, res.data.endTime];
        res.data.userGrade = res.data.userGrade * 1;
        _this5.boole = res.data.status === 1 || res.data.status === 2;
        Object.keys(_this5.ruleForm).forEach(function (key) {
          if (res.data.hasOwnProperty(key)) {
            _this5.ruleForm[key] = res.data[key]; // 直接赋值更简洁有效
          }
        });
        _this5.dialogVisible = true;
      });
    },
    initRuleForm: function initRuleForm() {
      this.ruleForm = {
        id: null,
        activityName: '',
        headPic: '',
        tagPic: '',
        userType: '',
        userGrade: '',
        perLimit: '',
        goodsLimit: '',
        bgColor: '#F8F8F8',
        remark: '',
        ruleTxt: null,
        timeArray: [],
        startTime: '',
        //	活动开始时间
        endTime: '' //	活动结束时间
      };
    },
    handleClose: function handleClose() {
      this.initRuleForm();
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    },
    del: function del(val) {
      var _this6 = this;
      this.$confirm('是否确认删除此活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _wedding.del_act)({
          id: val.id
        }).then(function (res) {
          if (res.data) {
            _this6.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this6.activityList();
          }
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.activityList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.activityList();
    },
    activityList: function activityList() {
      var _this7 = this;
      (0, _wedding.get_act)(this.queryData).then(function (res) {
        _this7.total = res.data.total;
        _this7.tableData = res.data.data;
      });
    },
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.activityList();
    },
    initQueryData: function initQueryData() {
      this.queryData = {
        activityName: '',
        status: null,
        page: 1,
        size: 10
      };
    },
    onInitialize: function onInitialize() {
      this.initQueryData();
      this.activityList();
    }
  }
};